// Per-restaurant parameters of the backend's load-aware pickup wait model.
// Kitchen load is measured in points: each item action contributes its
// workstation's prep weight. The quoted wait is base_wait_minutes plus
// step_minutes for every full points_per_step points of load, capped at
// max_wait_minutes. Orders above large_order_points are "large": they see
// the entire kitchen backlog, while small orders only see backlog from
// other small orders.
export type WaitConfig = {
  restaurant_id: string;
  base_wait_minutes: number;
  points_per_step: number;
  step_minutes: number;
  max_wait_minutes: number;
  large_order_points: number;
};

export type UpdateWaitConfigRequest = Omit<WaitConfig, "restaurant_id">;

// Mirror the backend's validation bounds for friendlier inline errors.
export const MAX_WAIT_CONFIG_MINUTES = 24 * 60;
export const MAX_WAIT_CONFIG_POINTS = 1_000_000;
